import { Row } from '@tanstack/react-table'

import { Log } from '@/types/logs'
import { sortLogsByTime } from './sortLogsByTime'

export const sortLogsByLocked = (rowA: Row<Log>, rowB: Row<Log>): number => {
    const logALocked = rowA.original.isLocked
    const logBLocked = rowB.original.isLocked

    if (logALocked && logBLocked) {
        return sortLogsByTime(rowA.original, rowB.original)
    }

    if (logALocked && !logBLocked) return 1
    if (logBLocked && !logALocked) return -1

    return 0
}
